import ChooseCardToAddPage from '@/components/add-card/ChooseCardToAddPage'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  insertAfterIndex: z.number().optional()
})

export const Route = createFileRoute('/_protected/_site/add-card/')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  return <ChooseCardToAddPage />
}
